import { render, staticRenderFns } from "./MacrosDelete.vue?vue&type=template&id=2b3c7730"
import script from "./MacrosDelete.vue?vue&type=script&lang=js"
export * from "./MacrosDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports